<template>
    <ui-input-box-floating class="autocomplete" :error="error">
        <ui-input v-model="localValue" type="text" :placeholder="placeholder" :disabled="disabled" @input="onInput"
            @blur="hideLater" @focus="search" />
        <ui-input-label>{{ label }}</ui-input-label>

        <div class="autocomplete-list" v-if="showSuggestions && suggestions.length">
            <div class="autocomplete-list-item" v-for="(item, index) in suggestions" :key="index"
                @mousedown.prevent="select(item)">
                {{ item.value }} <span v-if="(props.type == 'fms_unit')">{{ item.data.code || '' }}</span>
                <div v-if="(props.type == 'party')" class="autocomplete-list-item-info">
                    <span>{{ item.data?.inn || '' }}</span> <span>{{ item.data?.address?.value || '' }}</span>
                </div>
            </div>
        </div>
    </ui-input-box-floating>
</template>

<script setup>
import './style.css'
import { postUrl } from "../../run";

import { ref, watch } from 'vue'

const props = defineProps({
    modelValue: String,
    type: { type: String, required: true }, // например "address"
    placeholder: String,
    label: String,
    disabled: Boolean,
    error: Boolean,
    payload: Object
})

const emit = defineEmits(['update:modelValue', 'select'])

const localValue = ref(props.modelValue || '')
const suggestions = ref([])
const showSuggestions = ref(false)
let hideTimeout = null

watch(() => props.modelValue, val => {
    localValue.value = val
})

watch(localValue, val => {
    emit('update:modelValue', val)
})


function debounce(fn, delay) {
    let timeout
    return function (...args) {
        clearTimeout(timeout)
        timeout = setTimeout(() => fn.apply(this, args), delay)
    }
}

const search = debounce(async () => {

    if (!localValue.value || localValue.value.length < 2) {
        suggestions.value = []
        return
    }

    postUrl('https://lc.stone-xxi.ru/api_v2/api/autocomplete', {
        type: props.type,
        query: localValue.value,
        payload: props.payload || {}
    }).then((req) => {

        let jsonAutocomplete = JSON.parse(req)?.response?.suggestions
        suggestions.value = jsonAutocomplete || []
        showSuggestions.value = true

    }).catch(() => {
        suggestions.value = []
    })

}, 200)

function onInput() {
    search()
}

function select(item) {
    showSuggestions.value = false
    emit('select', item)
}

function hideLater() {
    hideTimeout = setTimeout(() => (showSuggestions.value = false), 100)
}
</script>

<style scoped>
/* Добавь стили при необходимости */
</style>